export class User {
  constructor(
    public mail: string,
    public password: string,
    public authType: string
  ) {}
}
